import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-red-700/20 text-white py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold text-red-600 mb-4">Alpha Epoxy Floors</h3>
            <p className="text-gray-400 text-sm">Sydney's premier epoxy flooring specialists with over 15 years of experience.</p>
          </div>
          <div>
            <h4 className="font-semibold text-red-600 mb-4">Contact Info</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>0451 945 455</li>
              <li>info@alphaepoxy.com.au</li>
              <li>Sydney, NSW</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-red-600 mb-4">Business Hours</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Mon - Fri: 7am - 5pm</li>
              <li>Saturday: 8am - 2pm</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-red-700/20 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2025 Alpha Epoxy Floors Sydney. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
